(function () {

    a3_cabin_reports.directive('instructions', instructions);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name notifications
   * @restrict E
   * @description
   *   Show selected module's trainee & instructor instructions
   * @example
   *   Usage:
   *   <instructions></instructions>
   * @ngInject
   */

    function instructions($filter, $routeParams, $location, UserFactory) {
        function link(scope, attrs) {
            scope.warningMessageText = "";
            scope.viewModuleHistory = viewModuleHistory;

            if(!scope.course.isParallel){
                var currentActiveOrderNo = scope.selectedPhase.OrderNo;
                
                scope.course.CrewCoursePhases.forEach(function(phase){
                    if(phase.OrderNo < currentActiveOrderNo && phase.Status != "Completed"){
                        phase.SequentialWarning = true;
                    }

                    //check if phase has any history
                    var oldSessions = [];
                    scope.trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                        var historyPhase = trainee.Phases.find(x => x.PhaseId == phase.PhaseId);
                        if(historyPhase && historyPhase.Sessions) oldSessions = oldSessions.concat(historyPhase.Sessions);
                    });

                    phase.hasHistory = oldSessions.length>0;
                });
            }

            scope.course.CrewCoursePhases.forEach(function(phase){
                phase.StatusClass = '';
                 
                if(phase.SequentialWarning){
                    phase.StatusClass="panel-danger border-left-red";
                    phase.BtnClass="bg-red text-white";
                }
                else if(phase.Status=='InProgress'){
                    phase.StatusClass="border-left-blue";
                    phase.TextClass="text-blue";
                    phase.BtnClass="bg-blue text-white";
                }
                else if(phase.Status=='Pending'){
                    phase.StatusClass="border-left-gray ";
                    phase.TextClass="text-gray";
                    phase.BtnClass="bg-gray text-white";
                }
                else if(phase.Status=='Completed'){
                    phase.StatusClass="border-left-green";
                    phase.TextClass="text-green";
                    phase.BtnClass="bg-green text-white";
                }

                if(phase.PhaseId==scope.selectedPhase.PhaseId){
                    phase.StatusClass= phase.StatusClass + " panel-info";
                }
            });

            var furtherAheadPhases = [];
            furtherAheadPhases = scope.course.CrewCoursePhases.filter(x => x.SequentialWarning);
            furtherAheadPhases  = $filter('orderBy')(furtherAheadPhases, 'OrderNo');

            if(furtherAheadPhases.length>0){
                scope.course.SequenceWarning = true;
                scope.warningMessageText = "<strong>" + furtherAheadPhases[furtherAheadPhases.length-1].Title + "</strong> is not completed. Confirm that you want to continue to <strong>" + scope.selectedPhase.Title +".</strong>"
            }

            scope.traineeInstructions = scope.selectedPhase.TraineeInstructions;
            scope.examinerInstructions = scope.selectedPhase.ExaminerInstructions;

            scope.isInstructorView = false;
            var traineesAimsIds = scope.trainees.map(x => x.AimsId);

            var user = UserFactory.getUser();

          if(!traineesAimsIds.includes(user.aimsId)){
            scope.isInstructorView = true;
          }

          scope.status = {
            isInstructorOpen: true,
            isTraineeOpen: false
          }

            scope.continueSubmission = continueSubmission;
            scope.cancelSubmission = cancelSubmission;

            function continueSubmission(){
                scope.course.SequenceWarning = false;
            }

            function cancelSubmission(){
                if(scope.isGround){
                    gotoGroundDuty();
                }
                else{
                    gotoCrewRoute();
                }

            }

            function gotoGroundDuty() {
                $location.path('/groundDuty/' + Number($routeParams.dutyId));
            }

            function gotoCrewRoute() {
                var dutyNo = scope.crewRouteDuty.DutyNo;
                var dutyDay = scope.crewRouteDuty.DutyDay;
                $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
            }

            function viewModuleHistory(phaseId){
                var courseId = Number($routeParams.courseId);
                var dutyId = Number($routeParams.dutyId);
                var date = $routeParams.date;     
                       

                if(dutyId) {
                    $location.path('/groundHistory/' + courseId + '/' + dutyId + '/' + date + '/' + phaseId);
                }
                else {
                    var dutyNo = scope.crewRouteDuty.DutyNo;
                    var dutyDay = scope.crewRouteDuty.DutyDay;   
                    $location.path('/flightHistory/' + courseId + '/' + dutyNo + '/' + dutyDay + '/' + date + '/' + phaseId);
                }               
            }
        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/instructions.tpl.html",
            scope : false,
            terminal: true,
            link: link
        }
    }
})();